import { visit } from './visit.js';
export * from './visit.js';
const remarkRewrite = (handle) => {
    return transformer;
    function transformer(tree) {
        visit(tree, (node, index, parent) => {
            if (handle && typeof handle === 'function') {
                handle(node, index, parent);
            }
        });
    }
};
export default remarkRewrite;
//# sourceMappingURL=index.js.map